export const corporate = {
  "hero": {
    "title": "About DONKEY TRAVEL",
    "subtitle": "Discover our story, our vision, and the passionate team that is reinventing home exchange for the most demanding hosts."
  },
  "mission": {
    "badge": "Our Mission",
    "title": "Democratizing premium peer-to-peer travel",
    "description": "DONKEY TRAVEL was created with a simple ambition: to enable the best guests to also enjoy the fruits of their labor. We believe that owners of exceptional homes, rated 4.5 and above, deserve a dedicated platform where they can trade their properties with confidence, without the financial friction of traditional rentals."
  },
  "philosophy": {
    "badge": "Philosophy & Values",
    "title": "At the heart of our club",
    "description": "We are not just a platform, we are a community built on trust, mutual respect and excellent hospitality.",
    "values": {
      "fair": {
        "title": "Equity",
        "desc": "Our trading system is designed to be fair and transparent. You offer time in your accommodation, you save time to travel. It's simple, with no hidden fees."
      },
      "local": {
        "title": "Immersion",
        "desc": "Home exchange is the opportunity to live like a local, discover regions off the beaten track, and create authentic connections."
      },
      "community": {
        "title": "Trust",
        "desc": "By reserving our club for guests rated 4.5+, we guarantee an impeccable level of requirement and quality within our network."
      }
    }
  },
  "team": {
    "badge": "The team",
    "title": "Behind DONKEY TRAVEL",
    "subtitle": "A platform born from a passion for travel and hospitality.",
    "members": {
      "ceo": {
        "name": "Sylvain",
        "role": "Founder & CEO",
        "bio": "A passionate host for years, Sylvain imagined DONKEY TRAVEL by himself looking for a solution to travel for free while promoting his own accommodation. Driven by the desire to create the best European exchange club, he ensures the excellence of the community every day."
      }
    }
  },
  "investors": {
    "badge": "Investors & Partners",
    "title": "Join the adventure",
    "description": "DONKEY TRAVEL is growing and we are always open to strategic opportunities to accelerate our development across Europe.",
    "cta": "Contact us"
  }
};
